import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 20px;

  border-bottom: 1px solid ${({ theme }) => theme.colors.neutral[40]};

  svg {
    color: ${({ theme }) => theme.colors.heading};
  }

  h1 {
    font-weight: 600;
    font-size: 20px;
    color: ${({ theme }) => theme.colors.heading};
  }
`;
